import styled from 'styled-components'

import { CustomFieldRestriction } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { semanticColors } from '@avantstay/backoffice-core'

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const areaStylesByRestriction = {
  [CustomFieldRestriction.essential]: {
    border: `2px dashed ${semanticColors.warningMedium}`,
  },
  [CustomFieldRestriction.required]: {
    border: `2px dashed ${semanticColors.failureMedium}`,
  },
  [CustomFieldRestriction.optional]: {},
}
